import * as React from 'react';

import {CTA} from '@volkswagen-onehub/components-core';
import {Close} from '@volkswagen-onehub/icons-core';

interface FullscreenGalleryLayerCloseButtonProps {
    btnCloseLabel?: string;
    onClick(): void;
}

export const FullscreenGalleryLayerCloseButton = (
    props: FullscreenGalleryLayerCloseButtonProps
) => {
    const {onClick, btnCloseLabel} = props;

    return (
        <CTA
            key="close"
            tag="button"
            onClick={onClick}
            aria-label={btnCloseLabel}
            emphasis="secondary"
            icon={<Close aria-hidden variant="small" />}
            size="small"
        />
    );
};
